import { useSearchRouteInfo } from '@aibees/elephant/hooks';
import { SearchBrowseParams } from '@aibees/elephant/types';
import { intersection } from 'lodash-es';
import {
  getFilterFields,
  getFilteringFields,
} from '../../../components/filter-tags/utils';
import { SearchFilter } from '../../../types';

export function useOpenedItems(
  params: Partial<SearchBrowseParams>,
  filter: SearchFilter,
  mainItems?: SearchFilter[],
  moreItems?: SearchFilter[]
) {
  const { type, table } = useSearchRouteInfo();
  const filteringFields = getFilteringFields(table, params, filter);

  const main = mainItems?.reduce((acc, curr) => {
    const fields = getFilterFields(curr);
    if (intersection(filteringFields, fields)?.length)
      return [...acc, ...[curr.field as string]];
    return acc;
  }, [] as string[]);

  const more = moreItems?.reduce((acc, curr) => {
    const fields = getFilterFields(curr);
    if (intersection(filteringFields, fields)?.length)
      return [...acc, ...[curr.field as string]];
    return acc;
  }, [] as string[]);

  return [main, more];
}
